export default __webpack_public_path__ + "static/media/GovZone.d46d7ec9272b805dcd86cb1428ab8048.webp";